import type { ParticipantV4 } from "@/types/participant";

export type AssessmentStatus = "invited" | "started" | "finished";

// Participant.state: 0 = invited, 1 = started, 2 = finished
const stateToStatus: Record<number, AssessmentStatus> = { 0: "invited", 1: "started", 2: "finished" };

export const statusRouteName: Record<AssessmentStatus, string> = {
  invited: "invitations",
  started: "in-progress",
  finished: "finished",
};

export function getAssessmentStatus(assessment: ParticipantV4): AssessmentStatus {
  return stateToStatus[assessment.state] ?? "invited";
}

export function formatDate(date: string, locale: string): string {
  if (!date) return "";
  return new Date(date).toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" });
}
